import { BorderBox, Position, Text } from '@trmediaab/zebra';

const Popular = () => (
  <Position.absolute top="8px" right="-10px">
    <Position.relative
      bg="offersPage.badge.background"
      color="offersPage.badge.foreground"
      px="2"
      py="1"
    >
      <Text
        fontWeight="bold"
        fontSize={{ _: 0, md: 1 }}
        textTransform="uppercase"
      >
        Populärt val
      </Text>
      <Position.absolute top="100%" right="0">
        <BorderBox
          borderWidth="5px"
          borderColor="offersPage.badge.background"
          borderRightColor="transparent"
          borderBottomColor="transparent"
        />
      </Position.absolute>
    </Position.relative>
  </Position.absolute>
);

export default Popular;
